// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_pYzae","foot_link":"index_foot_link_hK2Dm","list":"index_list_cSPQA","link":"index_link_Ax4En","copyright":"index_copyright_TP-nP"};